import { init } from './archetype-flow.js';

init();
